Wee.fn.make('extension', {
	_construct: function() {
		var disabled = '-is-disabled',
			active = '-is-active',
			hidden = '-is-hidden';

		$.chain({
			disable: function() {
				this.addClass(disabled);

				return this;
			},

			enable: function() {
				this.removeClass(disabled);

				return this;
			},

			isDisabled: function() {
				return this.hasClass(disabled);
			},

			isEnabled: function() {
				return ! this.hasClass(disabled);
			},

			activate: function() {
				this.addClass(active);

				return this;
			},

			deactivate: function() {
				this.removeClass(active);

				return this;
			},

			isActive: function() {
				return this.hasClass(active);
			},

			isInactive: function() {
				return ! this.hasClass(active);
			},

			isHidden: function() {
				return this.hasClass(hidden);
			},

			toggleHidden: function() {
				if (this.isHidden()) {
					this.removeClass(hidden);
				} else {
					this.addClass(hidden);
				}

				return this;
			},

			toggleActive: function() {
				if (this.isActive()) {
					this.deactivate();
				} else {
					this.activate();
				}

				return this;
			},

			toggleDisabled: function() {
				if (this.isDisabled()) {
					this.enable();
				} else {
					this.disable();
				}

				return this;
			}
		});
	}
});